import { Inject, Injectable } from '@angular/core';
import { User } from '../../admin/models/user.model';
import { ApiService } from '../../../shared/services/api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { API_BASE_URL } from '../../../shared/tokens/api.tokens';
import { catchError, Observable, tap } from 'rxjs';
import { ExistenceChecker } from '../../../shared/interfaces/existence-checker.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ApiService<User> implements ExistenceChecker<string, number> {

  override searchFields: string[] = ['email', 'firstName', 'lastName'];
  override _baseUrl: string;

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}users/`;    
  }  
  
  exists(email: string, userId?: number) {
    let params = new HttpParams().set('email', email);
    if (userId !== undefined && userId !== null) {
      params = params.set('userId', userId.toString());
    }
    return this.http.get<boolean>(`${this._baseUrl}email-exists`, { params: params }).pipe(
      catchError(this.handleError)
    );
  }  

  getMe(): Observable<User> {
    return this.http.get<User>(`${this._baseUrl}me`).pipe(
      catchError(this.handleError)
    );
  }

  
}
